<template>
  <div class="news-container">
    <Header></Header>
    <div class="top">
      <div class="title">热门资讯</div>
      <div class="search-input" style="border-radius: 100px">
        <a-input
          size="large"
          v-model="search"
          placeholder="请输入关键字搜索"
          @keyup.enter="didClick_search()"
        />
        <img
          src="../../assets/images/news/search.png"
          alt=""
          @click="didClick_search"
        />
      </div>
    </div>
    <div class="news-list">
      <div class="news-content" v-if="searchData.length > 0 && !isLoading">
        <div
          class="news-item"
          v-for="(item, index) in searchData"
          :key="index"
          @click="lookDetail(item)"
        >
          <div class="cover">
            <img
              :src="
                $store.state.isMobile
                  ? item.showImagesRealPath[1]
                  : item.showImagesRealPath[0]
              "
              alt=""
            />
          </div>
          <div class="content">
            <div class="title">{{ item.title }}</div>
            <div class="desc">{{ item.summaryChange }}</div>
            <div class="info">
              <div class="time">{{ item.date }}</div>
              <div class="more">查看详情</div>
            </div>
          </div>
        </div>
      </div>
      <div class="news-content" v-if="searchData.length === 0 || isLoading">
        <div class="no-data flex flex-direction align-center justify-center">
          <img class="no-data-img" src="../../assets/images/news/no-data.png" />
          <div class="no-data-text">
            暂无相关信息<br />
            请尝试输入不同的关键词来获取更多搜索结果
          </div>
        </div>
      </div>
    </div>
    <suspension></suspension>
    <cook-tip></cook-tip>
    <foot></foot>
  </div>
</template>

<script>
import Header from "../../components/Header";
import Foot from "../../components/Foot";
import CookTip from "../../components/CookTip";
import { staticApi } from "../../services";
import $store from "../../store";
import Suspension from "../../components/Suspension";

export default {
  name: "news",
  data() {
    return {
      news: [],
      search: "",
      isLoading: true,
      searchData: [],
    };
  },
  components: {
    Header,
    Foot,
    CookTip,
    Suspension,
  },
  created() {
    this.getNewsList(); //获取热门资讯列表
  },
  methods: {
    //获取热门资讯列表
    getNewsList() {
      staticApi
        .request(
          `/${this.$config.tenantId}/seminar/${this.$config.seminarId}/article/list/${this.$config.newsId}.json`
        )
        .then((res) => {
          let newsList = res.content.items;
          this.isLoading = false;
          for (const item of newsList) {
            item.date = this.formatTime(
              new Date(item.pushTime * 1000),
              "YYYY/MM/DD"
            );
            // item.desc = item.summary.replace(/\^source=(.*)/, "");
            //TODO 上正式之后 如何替换
            if (item.showImagesRealPath[0]) {
              item.showImagesRealPath[0] = item.showImagesRealPath[0].replace(
                /^.*\/\/hwyhw.smarket.net.cn/,
                "https://hwyhw-files.smarket.net.cn"
              );
            }
            if (item.showImagesRealPath[1]) {
              item.showImagesRealPath[1] = item.showImagesRealPath[1].replace(
                /^.*\/\/hwyhw.smarket.net.cn/,
                "https://hwyhw-files.smarket.net.cn"
              );
            } else {
              item.showImagesRealPath[1] = item.showImagesRealPath[0];
            }
            if (item.summary.indexOf("^source=") > 1) {
              item.summaryChange = item.summary.substring(
                item.summary.indexOf("^source=") + 8,
                item.summary.length
              );
            } else {
              item.summaryChange = item.summary;
            }

            if (this.$config.articleRelation[item.title]) {
              item.url = this.$config.articleRelation[item.title];
            }
          }
          //时间排序
          newsList.sort((a, b) => {
            return a.pushTime - b.pushTime;
          });
          //排序
          newsList.sort((a, b) => {
            return b.order - a.order;
          });
          if (res.result === 0) {
            this.news = newsList;
            this.searchData = newsList;
          }
        })
        .catch((err) => {
          console.error("获取列表失败", err);
        });
    },
    //查看更多 外链
    lookDetail(option) {
      window._hw("send", "action", "news_page_news_click", {
        content_name: option.title, // 内容名称
        product_tag: option.tags[0] ? option.tags[0].name : "", //产品标签
        industry_tag: option.tags[1] ? option.tags[1].name : "", //行业标签
        solution_tag: option.tags[2] ? option.tags[2].name : "", //解决方案标签
        hw_relation: this.$store.state.userInfo.hwRelation, //与华为关系
      });
      //完成任务
      this.$store
        .dispatch("interaction/onCompleteTask", {
          desc: "洞察之眼",
          objectId: option.id,
        })
        .finally(() => {
          window.open(option.url);
        });
    },
    //搜索
    didClick_search() {
      //todo 搜索接口
      var search = this.search;
      window._hw("send", "action", "news_page_search_click", {
        content_name: search, // 内容名称
        hw_relation: this.$store.state.userInfo.hwRelation, //与华为关系
      });
      if (search) {
        var search1 = search.toLowerCase();
        this.searchData = this.news.filter(function (product) {
          return Object.keys(product).some(function (key) {
            return String(product["title"]).toLowerCase().indexOf(search1) > -1;
            return (
              String(product["summary"]).toLowerCase().indexOf(search1) > -1
            );
            // return String(product[key]).toLowerCase().indexOf(search) > -1;
          });
        });
      } else {
        this.searchData = this.news;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@media screen and (min-width: 992px) {
  @import "./css/index/pc.scss";
}

@media screen and (max-width: 992px) {
  @import "./css/index/wap.scss";
}
</style>
